import React from "react";
import { Paragraph as FusionParagraph } from "@singlestore/fusion/components/typography";

type ParagraphProps = React.ComponentProps<typeof FusionParagraph>;

export function Paragraph({
    children,
    ...rest
}: React.PropsWithChildren<ParagraphProps>) {
    return (
        <FusionParagraph {...rest} variant="body-3">
            {children}
        </FusionParagraph>
    );
}
